import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToSection, scrollTop } from "@/lib/scroll";

export default function ScrollToTop() {
  const { pathname, hash, state } = useLocation();

  useEffect(() => {
    if (state?.scrollTo) {
      const t = setTimeout(() => scrollToSection(state.scrollTo), 350);
      return () => clearTimeout(t);
    }
    if (hash && hash.length > 1) {
      const t = setTimeout(() => scrollToSection(hash), 350);
      return () => clearTimeout(t);
    }
    scrollTop();
  }, [pathname, hash, state?.scrollTo]);

  return null;
}
